
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'ShakeImage',
})
export default class ShakeImage extends Vue {
  @Prop({ type: String, default: '' }) readonly src!: string;
  @Prop({ type: String, default: '' }) readonly text!: string;
  @Prop({ type: String, default: '10px' }) readonly mrB!: string;
  @Prop({ type: String, default: '93px' }) readonly width!: string;
  @Prop({ type: String, default: '92px' }) readonly height!: string;
  @Prop({ type: Boolean, default: true }) readonly isImgDiv!: boolean;
  @Prop({ type: Number, default: 500 }) readonly pressTime!: number;
  @Prop({ type: Boolean, default: false }) readonly isDragging!: boolean;
  @Prop({ type: Number, default: 4 }) readonly isMaxLen!: number;
  @Prop({ type: Boolean, default: false }) readonly isMax!: boolean;

  private isShaking = false;
  private longPressTimer: number | null = null;
  private startX = 0;
  private startY = 0;
  private moveThreshold = 5; // 移动阈值，单位为像素
  private hasMoved = false;

  created() {
    this.$eventBus.$on('startShake', this.startShake);
    this.$eventBus.$on('stopShake', this.stopShake);
  }

  beforeDestroy() {
    this.$eventBus.$off('startShake', this.startShake);
    this.$eventBus.$off('stopShake', this.stopShake);
    this.clearLongPressTimer();
  }

  handleTouchStart(e: TouchEvent) {
    if (this.isMax && this.isShaking) {
      this.$toast(`最多显示${this.isMaxLen}个`)
      return;
    }
    if (this.isDragging) return;
    this.startX = e.touches[0].pageX;
    this.startY = e.touches[0].pageY;
    this.hasMoved = false;
    // 设置长按定时器
    this.longPressTimer = window.setTimeout(() => {
      if (!this.hasMoved) {
        this.handleLongPress();
      }
    }, this.pressTime);
  }

  handleTouchMove(e: TouchEvent) {
    if (this.isDragging) return;
    const moveX = Math.abs(e.touches[0].pageX - this.startX);
    const moveY = Math.abs(e.touches[0].pageY - this.startY);
    // 如果移动距离超过阈值，标记为已移动
    if (moveX > this.moveThreshold || moveY > this.moveThreshold) {
      this.hasMoved = true;
      this.clearLongPressTimer();
    }
  }

  handleTouchEnd() {
    this.clearLongPressTimer();
  }

  handleLongPress() {
    if (!this.isShaking) {
      this.$eventBus.$emit('startShake');
    }
  }

  startShake() {
    if (!this.isDragging) {
      this.isShaking = true;
      this.$emit('handlePress');
    }
  }

  stopShake() {
    this.isShaking = false;
  }

  clearLongPressTimer() {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
  }
}
